import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class GlobalState {

  private _subscriptions: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();

  constructor() { }

  notifyDataChanged(event: string, value: any) {
    const subscriber = this.getSubscription(event);
    if (environment.production !== true) {
      console.log('%c action :' + event + ',nextState :' + JSON.stringify(value), 'background: #222; color: #bada55');
    }
    subscriber.next(value);
  }

  watch(event: string) {
    const subscriber = this.getSubscription(event);
    if (environment.production !== true) {
      console.log('%c subscribe :' + event + ',currentState :' + JSON.stringify(subscriber.value), 'background: #222; color: #bada55');
    }
    return subscriber;
  }
  private getSubscription(event) {
    let subject = this._subscriptions.get(event);
    if (!subject) {
      subject = new BehaviorSubject(null);
      this._subscriptions.set(event, subject);
    }
    return subject;
  }
}
